import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "mlsImportPreviouslyViewed",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("MLS Data Available for Previously Viewed Properties")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, " QuickSource has detected that you've imported MLS data for the following previously viewed properties: ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, " Click \"Run Data Preference\" to automatically fill the data preference using your imported MLS data for these properties. To review and choose data fields manually click \"Close and Review\". Properties that have already been viewed will have a green checkmark on the tab. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalHeader, { showToolBarClose: false }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            _hoisted_5,
            _createElementVNode("div", null, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.viewedList, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.compNumber
                  }, _toDisplayString(this.getFormatted(item)), 1))
                }), 128))
              ])
            ]),
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.runDataPreferences && _ctx.runDataPreferences(...args)))
            }, "Run Data Preference"),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeAndReview && _ctx.closeAndReview(...args)))
            }, "Close and Review")
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}